@if (floorList()) {
  <div class="building-plan-wrapper">
    <div class="flex building-plan">
      <div class="floors-sidebar">
        <ul>
          @for (floor of floorList(); track floor.id) {
            <li
              class="floor-name text-ellipsis overflow-hidden px-2 whitespace-nowrap w-[101px]"
              [routerLink]="['/dashboard', config().locationId, floor.id]"
            >
              {{ floor.friendlyName }}
            </li>
          }
        </ul>
      </div>
      <div class="rooms-container w-full">
        <ul>
          @for (floor of floorList(); track floor.id) {
            <li>
              <ul class="test-floor-{{ floor.id }}">
                @for (room of floor.rooms; track room.id) {
                  <li
                    class="inline-block hover:cursor-pointer"
                    [class.incident-critical-severity]="room.status === EntityStatus.Active && (room.incidentCountBySeverity.critical || room.incidentCountBySeverity.major)"
                    [class.incident-minor-severity]="room.status === EntityStatus.Active && room.incidentCountBySeverity.minor && !room.incidentCountBySeverity.critical && !room.incidentCountBySeverity.major"
                    [matTooltip]="room.friendlyName + ':&#10;' + (room.incidentCountBySeverity.critical + room.incidentCountBySeverity.major + room.incidentCountBySeverity.minor) + ' inc | ' + room.devicesCount + ' dev'"
                    [ngClass]="floor.status !== EntityStatus.Archived ? room.status : floor.status"
                    [routerLink]="['/dashboard', config().locationId, floor.id, room.id]"
                    matTooltipClass="whitespace-pre-line"
                  ></li>
                }
                @for (_ of (floor.rooms?.length | avsTimes : roomFitsNumber); track $index) {
                  <li class="empty-room inline-block"></li>
                }
              </ul>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
} @else {
  <avs-no-data-placeholder noDataText="No Floors yet" />
}
